import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AppShellNoRenderDirective} from "./app-shell-no-render-directive";
import {AppShellRenderDirective} from "./app-shell-render.directive";
import { ImageCheckDirective } from './image-check.directive';
import { FixScrollDirective } from './fix-scroll.directive';



@NgModule({
  declarations: [
    AppShellNoRenderDirective,
    AppShellRenderDirective,
    ImageCheckDirective,
    FixScrollDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AppShellNoRenderDirective,
    AppShellRenderDirective,
    ImageCheckDirective,
    FixScrollDirective
  ]
})
export class DirectivesModule { }
